<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'page-evaluations360-polls',
};
</script>


// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/page-evaluations360-polls.vue